const REDIRECT_URLS_BY_WORKSPACE = {
  '06cb8298-caa4-4eb2-bf16-faf52bae0951': 'https://www.firstrepublic.com/', // Octavio's staging id
  '8bb3f7ba-9372-4ce3-8f6f-c863262881e6': 'https://www.firstrepublic.com/', // Rene's staging id
};

export function getDefaultRedirectUrl(workspaceId): string | undefined {
  return REDIRECT_URLS_BY_WORKSPACE[workspaceId];
}
